//==============================
// Santa Barbara Map
//==============================

function onPageLoad() {
  
  // loader out animations

  setTimeout(function() {
    //after loader animations
    $('.js-sb-map').addClass('animate');
  }, 1000);
}

$(window).on('load', function() {
  onPageLoad();
});

$(window).bind('pageshow', function(event) {
  if (event.originalEvent.persisted) {
    onPageLoad();
  }
});


